// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { screen } from "@gcg/XDL/Helpers";
import { searchBoxStyles } from "@insite/content-library/Widgets/Addresses/AddressBookSearchBox";
import Search from "@insite/mobius/Icons/Search";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

searchBoxStyles.searchText = {
    iconProps: { src: Search },
    cssOverrides: {
        formInputWrapper: css`
            ${screen("lte", "sm")`margin-left: 15px;`}
        `,
        // XNG-Change GCG-431
        formField: css`
        &&& {
            input {
                padding-right: 30px;
            }
            svg {
                color: ${getColor("primary")};
                width: 25px;
                height: 25px;
            }
        }
        `
    },
};
